/* eslint-disable no-var */
import { call, put, all, takeLatest } from "redux-saga/effects";

import {
  dashboardProposalSuccess,
  dashboardProposalFailure,
  dashboardProposalChanged,
  dashboardProposalDeleteChanged,
  dashboardProposalDeleteFailure,
  dashboardProposalDeleteSuccess,
  dashboardProposalExportSuccess,
  dashboardProposalExportFailure,
  dashboardProposalExportChanged,
} from "./Dashboard.action";
import {
  dashboardFetchProposalAPI,
  dashboardDeleteProposalAPI,
  dashboardExportProposalAPI,
} from "./Dashboard.service";
import dashboardProposalTypes from "./Dashboard.types";
import { encryptData } from "../../_common/enode-decode";
export function* fetchIncompleteProposalData({ payload }: any) {
  var key: any = "LeadMasterListAdminKey";
  try {
    const jsonData: any = {
      InputSearch: payload.InputSearch,
      Limit: payload.Limit,
      RowsPerPage: payload.RowsPerPage,
      Country: payload.Country,
      Filter: payload.Filter,
      Status: payload.Status,
      saleStatusName:
        payload.saleStatusName ??
        payload.SaleStatus ??
        payload.saleStatus ??
        payload.CurrentStatus ??
        payload.currentStatus ??
        payload.Status,
      SubmittedProposalFromDate: payload.SubmittedFromDate,
      SubmittedProposalToDate: payload.SubmittedToDate,
      IsApplied: payload.Applied,
      SearchBusinessName: payload.BusinessName,
      SearchBusinessNumber: payload.BusinessNumber,
      SearchBusinessProduct: payload.ProductID,
      SearchBusinessLeadSource: payload.LeadSourceID,
      // CreatedProposalFromDate: payload.createdDateFrom,
      // CreatedProposalToDate: payload.createdDateTo,
      PaidoutProposalFromDate: payload.PaidOutFromDate,
      PaidoutProposalToDate: payload.PaidOutToDate,
      // LenderStatus: payload.LenderStatus,
      PhoneNumber: payload.PhoneNumber,
      LastDialledFromDate: payload.LastDialledFromDate,
      LastDialledToDate: payload.LastDialledToDate,
      Region: payload.LeadStatus,
      InstanceName: payload.InstanceName,
      ProductID: payload.ProductID,
      LeadSourceID: payload.LeadSourceID,
      CreatedProposalFromDate: payload.SearchFromDate,
      CreatedProposalToDate: payload.SearchToDate,
      LenderStatus: payload.DealStatus,
      Applied: payload.Applied,
      SubmittedFromDate: payload.SubmittedFromDate,
      SubmittedToDate: payload.SubmittedToDate,
      PaidOutFromDate: payload.PaidOutFromDate,
      PaidOutToDate: payload.PaidOutToDate,
      LenderID: payload.Lender,
      DealStatus: payload.DealStatus,
      saleStatus:
        payload.saleStatusName ??
        payload.SaleStatus ??
        payload.saleStatus ??
        payload.CurrentStatus ??
        payload.currentStatus ??
        payload.Status,
      CurrentStatus:
        payload.saleStatusName ??
        payload.SaleStatus ??
        payload.saleStatus ??
        payload.CurrentStatus ??
        payload.currentStatus ??
        payload.Status,
      DocumentType: payload.DocumentType,
      UserID: payload.UserID,
      BranchID: payload.BranchID,
      userType: payload.userType,
      UserLevel: payload.UserLevel,
      // ---- Call / dialer filters (same contract as the Pre-Proposal page) ----
      DispositionCategory: payload.DispositionCategory,
      Disposition: payload.Disposition,
      PreviousDisposition: payload.PreviousDisposition,
      TalkTimeBucket: payload.TalkTimeBucket,
      SicSector: payload.SicSector,
      SicGroup: payload.SicGroup,
      DataProvider: payload.DataProvider,
      LeadGroup: payload.LeadGroup,
      ExcludeDND: payload.ExcludeDND,
      OnlyDND: payload.OnlyDND,
      TaggedRPC: payload.TaggedRPC,
      TaggedSelfCallback: payload.TaggedSelfCallback,
      TaggedGatekeeper: payload.TaggedGatekeeper,
      TaggedGKNotInterested: payload.TaggedGKNotInterested,
    };
    console.log(jsonData);

    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const response = yield call(dashboardFetchProposalAPI, encodeData);
    if (response.data.StatusCode === "100") {
      yield put(dashboardProposalFailure(response.data));
    } else {
      yield put(dashboardProposalSuccess(response.data));
    }
  } catch (error) {
    yield put(dashboardProposalFailure(error));
  }
}

export function* handleProposalChanged() {
  yield put(dashboardProposalChanged());
}

export function* watchIncompleteProposalStart() {
  yield takeLatest(
    dashboardProposalTypes.DASHBOARD_PROPOSAL_START,
    fetchIncompleteProposalData,
  );
}

export function* handleProposalReset() {
  yield takeLatest(
    dashboardProposalTypes.DASHBOARD_PROPOSAL_RESET,
    handleProposalChanged,
  );
}

// delete lead

export function* dashboardDeleteProposal({ payload }: any) {
  const key: any = "DeleteLeadsKey";

  try {
    const jsonData: any = {
      lm_id: payload.lm_ID,
      LeadName: payload.LeadSourceName,
      UserID: payload.userID,
      username: payload.userName,
    };
    const encodeJsonData = encryptData(jsonData, key);
    // @ts-ignore
    const response = yield call(dashboardDeleteProposalAPI, encodeJsonData);
    if (response.data.StatusCode === "100") {
      yield put(dashboardProposalDeleteFailure(response.data));
    } else {
      yield put(dashboardProposalDeleteSuccess(response.data));
    }
  } catch (error) {
    yield put(dashboardProposalDeleteFailure(error));
  }
}

export function* handleProposalDeleteChanged() {
  yield put(dashboardProposalDeleteChanged());
}

export function* DashboardDeleteProposalStart() {
  yield takeLatest(
    dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_START,
    dashboardDeleteProposal,
  );
}

export function* handleProposalDeleteReset() {
  yield takeLatest(
    dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_RESET,
    handleProposalDeleteChanged,
  );
}

// EXPORT

export function* fetchDashboardProposalExport({ payload }: any) {
  // const key: any = "LeadMasterListAdminKey";
  const key: any = "CreateRequestReportKey";

  try {
    const jsonData: any = {
      //   Limit: payload.Limit,
      //   Country: payload.Country,
      //   Filter: payload.Filter,
      //   Status: payload.Status,
      //   SubmittedProposalFromDate: payload.submittedDateFrom,
      //   SubmittedProposalToDate: payload.submittedDateTo,
      //   IsApplied: payload.applied,
      //   SearchBusinessName: payload.businessName,
      //   SearchBusinessNumber: payload.businessNumber,
      //   SearchBusinessProduct: payload.product,
      //   SearchBusinessLeadSource: payload.leadSource,
      //   CreatedProposalFromDate: payload.createdDateFrom,
      //   CreatedProposalToDate: payload.createdDateTo,
      //   PaidoutProposalFromDate: payload.PaidoutProposalFromDate,
      //   PaidoutProposalToDate: payload.PaidoutProposalToDate,
      //   LenderID: payload.lender,
      //   LenderStatus: payload.LenderStatus,
      //   PhoneNumber: payload.PhoneNumber,
      //   InstanceName: payload.InstanceName,

      BranchID: payload.BranchID,
      IsFresh: payload.IsFresh,
      ConditionExec: payload.ConditionExec,
      ExistRequestID: 1,
      CreateDateTime: payload.CreateDateTime,
      RequestReportPage: payload.RequestReportPage,
      CompanyID: payload.CompanyID,
      RequestedBy: payload.RequestedBy,
      URL: payload.URL,
      MemberID: payload.MemberID,
      DateType: payload.DateType,
      InstanceName: payload.InstanceName,
    };
    console.log(jsonData);

    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    // @ts-ignore
    const response = yield call(dashboardExportProposalAPI, encodeData);

    // Since responseType is blob, we might not get a standard StatusCode field directly if it's a file
    // Check if the response is valid (e.g. status 200)
    if (response.status === 200) {
      yield put(dashboardProposalExportSuccess(response.data));
    } else {
      yield put(dashboardProposalExportFailure(response.data));
    }
  } catch (error) {
    console.log(error);
    yield put(dashboardProposalExportFailure(error));
  }
}

export function* dashboardExportStart() {
  yield takeLatest(
    dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_START,
    fetchDashboardProposalExport,
  );
}

export function* handleProposalExportChanged() {
  yield put(dashboardProposalExportChanged());
}

export function* handleProposalExportReset() {
  yield takeLatest(
    dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_RESET,
    handleProposalExportChanged,
  );
}

export function* DashboardSaga() {
  yield all([
    call(watchIncompleteProposalStart),
    call(handleProposalReset),
    call(DashboardDeleteProposalStart),
    call(handleProposalDeleteReset),
    call(dashboardExportStart),
    call(handleProposalExportReset),
  ]);
}
